import { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

const inputCls = "w-full h-10 px-3 rounded-md border text-sm bg-white";

export default function ChangePasswordModal({ onClose }) {
  const [form, setForm] = useState({ current: "", next: "", confirm: "" });
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (form.next !== form.confirm) return setError("New passwords do not match.");
    setSaving(true);
    setError("");
    try {
      await api.post("/auth/change-password", {
        current_password: form.current, new_password: form.next,
      });
      toast.success("Password changed");
      onClose();
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Could not change password.");
    } finally {
      setSaving(false);
    }
  };

  const field = (label, key, testid) => (
    <div>
      <label className="cw-caption block mb-1">{label}</label>
      <input type="password" value={form[key]} onChange={set(key)} required
        className={inputCls} style={{ borderColor: "var(--cw-border)" }} data-testid={testid} />
    </div>
  );

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4" data-testid="change-password-modal">
      <form onSubmit={submit} className="bg-white rounded-xl shadow-xl w-full max-w-md" style={{ color: "var(--cw-text, #111)" }}>
        <div className="flex items-center justify-between px-6 py-4 border-b" style={{ borderColor: "var(--cw-border)" }}>
          <h2 className="cw-h2">Change password</h2>
          <button type="button" onClick={onClose} data-testid="change-password-close-btn"><X size={20} /></button>
        </div>
        <div className="p-6 space-y-4">
          {field("Current password", "current", "change-password-current-input")}
          {field("New password", "next", "change-password-new-input")}
          {field("Confirm new password", "confirm", "change-password-confirm-input")}
          <p className="text-xs text-gray-500">At least 8 characters with an uppercase letter, a lowercase letter and a number.</p>
          {error && <p className="text-sm" style={{ color: "var(--cw-error)" }} data-testid="change-password-error">{error}</p>}
        </div>
        <div className="border-t px-6 py-4 flex justify-end gap-2" style={{ borderColor: "var(--cw-border)" }}>
          <button type="button" onClick={onClose} className="cw-btn-ghost" data-testid="change-password-cancel-btn">Cancel</button>
          <button type="submit" disabled={saving} className="cw-btn-primary" data-testid="change-password-submit-btn">
            {saving ? "Saving…" : "Update password"}
          </button>
        </div>
      </form>
    </div>
  );
}
